const serumThumbs = [...document.querySelectorAll('.serum-page .pdp-thumb')];
const serumMainPhoto = document.querySelector('#serum-main-photo');
let serumPhotoIndex = 0;
let serumPhotoRequest = 0;

function showSerumPhoto(index) {
  serumPhotoIndex = (index + serumThumbs.length) % serumThumbs.length;
  const thumb = serumThumbs[serumPhotoIndex];
  const request = ++serumPhotoRequest;
  serumMainPhoto.classList.add('is-changing');
  const preload = new Image();
  let revealed = false;
  const reveal = () => {
    if (revealed || request !== serumPhotoRequest) return;
    revealed = true;
    (window.BasicProductImages ? window.BasicProductImages.setImage(serumMainPhoto, thumb.dataset.src) : (serumMainPhoto.removeAttribute('srcset'), serumMainPhoto.src = thumb.dataset.src));
    serumMainPhoto.alt = thumb.dataset.alt;
    serumThumbs.forEach((button, buttonIndex) => {
      const active = buttonIndex === serumPhotoIndex;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    requestAnimationFrame(() => serumMainPhoto.classList.remove('is-changing'));
  };
  preload.onload = reveal;
  preload.onerror = reveal;
  (window.BasicProductImages ? window.BasicProductImages.setImage(preload, thumb.dataset.src, serumMainPhoto) : (preload.removeAttribute('srcset'), preload.src = thumb.dataset.src));
  if (preload.complete) reveal();
}

serumThumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSerumPhoto(index)));
document.querySelector('#serum-photo-prev')?.addEventListener('click', () => showSerumPhoto(serumPhotoIndex - 1));
document.querySelector('#serum-photo-next')?.addEventListener('click', () => showSerumPhoto(serumPhotoIndex + 1));

let serumTouchX = null;
const serumMainImage = document.querySelector('#serum-main-image');
serumMainImage?.addEventListener('touchstart', event => { serumTouchX = event.changedTouches[0].screenX; }, {passive:true});
serumMainImage?.addEventListener('touchend', event => {
  if (serumTouchX === null) return;
  const difference = event.changedTouches[0].screenX - serumTouchX;
  if (Math.abs(difference) > 45) showSerumPhoto(serumPhotoIndex + (difference < 0 ? 1 : -1));
  serumTouchX = null;
}, {passive:true});

const serumForm = document.querySelector('#serum-cart-form');
const serumQuantityInput = document.querySelector('#serum-quantity-input');
const serumQuantityOutput = document.querySelector('#serum-quantity-output');
const serumMinus = document.querySelector('#serum-quantity-minus');
const serumPlus = document.querySelector('#serum-quantity-plus');
const serumTotal = document.querySelector('#serum-total');
const serumButtonPrice = document.querySelector('#serum-button-price');
const serumButtonLabel = document.querySelector('#serum-button-label');
const serumShippingDetail = document.querySelector('#serum-shipping-detail');
const serumSticky = document.querySelector('#serum-mobile-buy');
const serumStickyQuantity = document.querySelector('#serum-sticky-quantity');
const serumStickyPrice = document.querySelector('#serum-sticky-price');
const serumClosing = document.querySelector('.pdp-closing');
let serumQuantity = 1;

function updateSerumQuantity() {
  const price = serumQuantity * 38;
  serumQuantityInput.value = String(serumQuantity);
  serumQuantityOutput.value = String(serumQuantity);
  serumQuantityOutput.textContent = String(serumQuantity);
  serumMinus.disabled = serumQuantity === 1;
  serumPlus.disabled = serumQuantity === 10;
  serumTotal.textContent = `CHF ${price}.–`;
  serumButtonPrice.textContent = `CHF ${price}.–`;
  serumButtonLabel.textContent = serumQuantity === 1 ? 'Ajouter mon sérum' : `Ajouter mes ${serumQuantity} sérums`;
  serumShippingDetail.textContent = price >= 70 ? 'Offerte pour cette sélection' : 'CHF 7 · offerte dès CHF 70';
  serumStickyQuantity.textContent = `${serumQuantity} ${serumQuantity === 1 ? 'flacon' : 'flacons'}`;
  serumStickyPrice.textContent = `CHF ${price}.–`;
}

serumMinus?.addEventListener('click', () => { serumQuantity = Math.max(1, serumQuantity - 1); updateSerumQuantity(); });
serumPlus?.addEventListener('click', () => { serumQuantity = Math.min(10, serumQuantity + 1); updateSerumQuantity(); });
serumForm?.addEventListener('submit', updateSerumQuantity);
updateSerumQuantity();

function updateSerumSticky() {
  if (!serumForm || !serumSticky || !serumClosing) return;
  const pastPurchase = serumForm.getBoundingClientRect().bottom < 80;
  const nearEnd = serumClosing.getBoundingClientRect().top < window.innerHeight * .82;
  const visible = window.innerWidth <= 700 && pastPurchase && !nearEnd && !document.body.classList.contains('menu-locked');
  serumSticky.classList.toggle('is-visible', visible);
  serumSticky.setAttribute('aria-hidden', String(!visible));
  serumSticky.inert = !visible;
}

window.addEventListener('scroll', updateSerumSticky, {passive:true});
window.addEventListener('resize', updateSerumSticky);
updateSerumSticky();
